import(/* webpackMode: "eager" */ "/app/src/app/company/layout.tsx");
